/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardDoughnutModel } from './DashboardDoughnutModel';
import {
  DashboardDoughnutModelFromJSON,
  DashboardDoughnutModelFromJSONTyped,
  DashboardDoughnutModelToJSON,
} from './DashboardDoughnutModel';

/**
 *
 * @export
 * @interface DashboardDoughnutModels
 */
export interface DashboardDoughnutModels {
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutModels
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutModels
   */
  maxCount: number;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutModels
   */
  restValue: number | null;
  /**
   *
   * @type {Array<DashboardDoughnutModel>}
   * @memberof DashboardDoughnutModels
   */
  results: Array<DashboardDoughnutModel>;
}

/**
 * Check if a given object implements the DashboardDoughnutModels interface.
 */
export function instanceOfDashboardDoughnutModels(value: object): value is DashboardDoughnutModels {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('maxCount' in value) || value['maxCount'] === undefined) return false;
  if (!('restValue' in value) || value['restValue'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function DashboardDoughnutModelsFromJSON(json: any): DashboardDoughnutModels {
  return DashboardDoughnutModelsFromJSONTyped(json, false);
}

export function DashboardDoughnutModelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardDoughnutModels {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    maxCount: json['max_count'],
    restValue: json['rest_value'],
    results: (json['results'] as Array<any>).map(DashboardDoughnutModelFromJSON),
  };
}

export function DashboardDoughnutModelsToJSON(value?: DashboardDoughnutModels | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    max_count: value['maxCount'],
    rest_value: value['restValue'],
    results: (value['results'] as Array<any>).map(DashboardDoughnutModelToJSON),
  };
}
